import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import * as api from '../schedulerApi';
import { Button, dateLabel } from './Shared';

// Date-only conversion for calendar presentation; the API decides eligibility.
const dateValue = value => value ? new Date(`${value}T12:00:00`) : null;
const dateKey = value => `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,'0')}-${String(value.getDate()).padStart(2,'0')}`;

export default function AvailabilityCalendar({ value, onChange }) {
 const [month,setMonth]=useState(null),[calendar,setCalendar]=useState(null);
 const [loading,setLoading]=useState(true),[error,setError]=useState(''),[retry,setRetry]=useState(0);
 useEffect(()=>{
  let live=true;setLoading(true);setError('');
  const params=month?{start:month,end:dateKey(new Date(dateValue(month).getFullYear(),dateValue(month).getMonth()+1,0,12))}:{};
  api.get('me/availability/date-options/',params).then(result=>{if(live)setCalendar(result);})
   .catch(e=>{if(live)setError(api.errorText(e));}).finally(()=>{if(live)setLoading(false);});
  return()=>{live=false;};
 },[month,retry]);
 const options=new Map((calendar?.days||[]).map(day=>[day.date,day]));
 const selectable=date=>!loading&&!error&&options.get(dateKey(date))?.selectable===true;
 const tomorrow=calendar?dateValue(calendar.today):null;
 if(tomorrow)tomorrow.setDate(tomorrow.getDate()+1);
 return <div className="availability-calendar-field">
  <div className="label" id="exception-date-label">Choose a date</div>
  <p className="caption" id="exception-date-help">Select a date starting tomorrow when you are available under your approved availability. Past dates, today, and unavailable dates are disabled. Unsaved weekly changes do not affect this calendar.</p>
  {calendar&&<div className="availability-calendar" aria-labelledby="exception-date-label" aria-describedby="exception-date-help" aria-busy={loading}>
   <DatePicker inline selected={dateValue(value)} openToDate={dateValue(calendar.today)} minDate={tomorrow}
    calendarStartDay={1} filterDate={selectable} onChange={date=>{if(date&&selectable(date))onChange(dateKey(date));}}
    onMonthChange={date=>setMonth(dateKey(new Date(date.getFullYear(),date.getMonth(),1,12)))}
    renderCustomHeader={({date,decreaseMonth,increaseMonth,prevMonthButtonDisabled})=><div className="availability-calendar-header">
     <Button variant="secondary" aria-label="Previous month" disabled={prevMonthButtonDisabled} onClick={decreaseMonth}><ChevronLeftIcon className="icon"/></Button>
     <strong aria-live="polite">{new Intl.DateTimeFormat('en-US',{month:'long',year:'numeric'}).format(date)}</strong>
     <Button variant="secondary" aria-label="Next month" disabled={date.getFullYear()>=9998&&date.getMonth()===11} onClick={increaseMonth}><ChevronRightIcon className="icon"/></Button>
    </div>}/>
  </div>}
  {loading&&<p className="caption" role="status">Checking your approved availability…</p>}
  {error&&<div className="error-message" role="alert">{error} <Button variant="secondary small" onClick={()=>setRetry(v=>v+1)}>Retry</Button></div>}
  {!loading&&!error&&calendar&&!calendar.days.some(day=>day.selectable)&&<p className="note" role="status">No eligible dates this month. Try another month. Changes to your usual availability need coordinator approval first.</p>}
  {calendar&&<p className="caption availability-calendar-selection" role="status">{value?`Selected: ${dateLabel(value)}`:'No date selected'} · Dates use {calendar.timezone}.</p>}
 </div>;
}
